var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandmarkFooterKnockout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 122 32",
    style: {
      enableBackground: "new 0 0 122 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{clip-path:url(#SVGID_00000132801729646093240000000004247967339606367145_)}.st1{fill:url(#SVGID_00000166677832081129229120000013417045381576148117_)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M0 0h122v32H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160906648641314071980000004332169675949234821_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000160906648641314071980000004332169675949234821_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121275445443047539980000013648728481927371414_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.1,
    y1: 1045.441,
    x2: 14.1,
    y2: 1087.888,
    gradientTransform: "translate(0 -1046)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffefbf"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#7be0dd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#66bdff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#1d96f3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121275445443047539980000013648728481927371414_)"
    },
    d: "m27.3 24.7-9.7 5.6v-.1c-.2-.4-.2-.8.1-2.3.3-1.1 1-2.6 2.3-4.8 1.2-1.8 3.6-5.3 8.3-10.1v9.9c0 .8-.4 1.4-1 1.8zm-12.9 7.1c-.4-.7-.6-1.5-.6-2.3 0-1 .2-1.9.5-2.8.4-1.2.9-2.3 1.4-3.4l2.8-5.3-4.4 4c-1.5 1.4-2.9 2.6-4.4 3.7-1.1.8-2.1 1.5-3.1 2.1l6.5 3.8c.4.2.9.3 1.3.3v-.1zM2.7 13.7C4.5 12 6.2 10.4 7.8 9c1-.9 2.1-1.8 3.1-2.8l.5-.5c.5-.5 1-.9 1.4-1.4l.1-.1v-.1c.2-.4.5-.8.9-.9.3-.2.6-.2 1-.2.1 0 .2.1.3.1.5.2.9.5 1.1.9.3.5.3 1 .1 1.4-.2.3-.3.6-.5.8-.3.4-.6.7-.8 1l-.1.1-1.8 1.8c-.8.7-1.7 1.6-2.8 2.6-1.5 1.3-2.4 2.2-4 3.6-1.6 1.5-3.1 3-4.4 4.4-.9.8-1.5 1.6-2 2.2V23c0 .7.4 1.4 1 1.7L3.3 26l.4-.2c2.3-1 4.5-2.2 6.6-3.6 2.6-1.7 5.6-3.9 9-6.6 2.7-2.2 5.6-4.7 8.9-7.7-.2-.3-.5-.6-.8-.8L15.3.1c-.6-.4-1.4-.4-2 0l-12.2 7c-.6.4-1 1-1 1.7v7.4c.7-.7 1.5-1.5 2.6-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7 15.9c.6-.4 1-1.1 1-1.8 0-1.3-1-2.3-2.3-2.3H40v8.5h3.7c1.3 0 2.4-1.1 2.4-2.4 0-.9-.6-1.7-1.4-2zm-3.8-3.3h2.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-2.5v-3zm2.8 6.9h-2.9v-3.1h2.9c.9 0 1.5.7 1.5 1.6v.1c0 .7-.7 1.4-1.5 1.4zm9.5-7.7L50.7 16l-2.6-4.2h-1l3.1 5v3.5h.9v-3.5l3.1-5.1h-1v.1zm9.3 8.7c-1.1 0-2.2-.3-3.1-.9v-.1l.3-1.2v-.1h.1c.9.5 1.8.8 2.8.9 1.4 0 1.6-.6 1.6-1.2s-.5-1.1-1.9-1.4c-1.7-.4-2.7-1.4-2.7-2.6s.8-2.5 3.1-2.5c.9 0 1.8.3 2.6.7v.1l-.3 1.3c0 .1-.1.1-.1.1h-.1c-.7-.4-1.5-.7-2.2-.7-1 0-1.5.4-1.5 1.1 0 .4.2.9 1.6 1.2 1.9.5 3 1.4 3 2.5 0 1.8-1.3 2.9-3.3 2.9l.1-.1zm46.5 0c-.8.1-1.4-.5-1.5-1.2v-.2l-.2.2c-.8.8-1.8 1.3-2.9 1.3-2.5-.3-4.3-2.5-4.1-4.9.2-2.2 1.9-3.8 4.1-4.1 1.2 0 2.3.5 3 1.4l.2.2.1-1.2c0-.1 0-.1.1-.1h1.3c.1 0 .1.1.1.1v6.9c0 .5.2.6.5.6h.3v.9c-.4 0-.7.1-1 .1zm-4.3-7.3c-1.6.1-2.8 1.5-2.7 3.1.1 1.5 1.3 2.6 2.7 2.7 1.7 0 2.7-1.1 2.7-2.9-.1-1.9-1-2.9-2.7-2.9zm-29.5 7.3c-.8.1-1.4-.5-1.5-1.2v-.2l-.2.2c-.8.8-1.8 1.3-2.9 1.3-2.5-.3-4.3-2.5-4.1-4.9.2-2.2 1.9-3.8 4.1-4.1 1.2 0 2.3.5 3 1.4l.2.2V12c0-.1.1-.1.1-.1h1.3c.1 0 .1.1.1.1v6.9c0 .5.2.6.5.6h.3v.8c0 .1-.1.1-.1.1-.3 0-.5.1-.8.1zm-4.3-7.3c-1.6.1-2.8 1.5-2.7 3.1.1 1.5 1.3 2.6 2.7 2.7 1.7 0 2.7-1.1 2.7-2.9-.1-1.9-1.1-2.9-2.7-2.9zm49.1 7.3c-1.8 0-2.1-1.6-2.1-2.8V13h-1c-.1 0-.1-.1-.1-.1v-1.1c0-.1 0-.1.1-.1h1V9.8c0-.1.1-.1.1-.1l1.5-.3v2.3h2c.1 0 .1.1.1.1v1.1c0 .1-.1.1-.1.1h-2v4.9c0 1 .3 1.3.9 1.3.5 0 .9-.2 1.3-.4.1 0 .1 0 .1.1l.2.8v.1c-.6.6-1.3.8-2.1.8l.1-.1zm-29.4 0c-.2 0-.3 0-.5-.1s-.3-.1-.4-.2c-.4-.3-.7-.6-.8-1.1v-3.9c0-2-.7-2.4-1.7-2.4-1.3.1-2.3 1-2.4 2.3V20c0 .1-.1.1-.1.1h-1.5c-.1 0-.1-.1-.1-.1v-4.8c0-2-.7-2.4-1.7-2.4-1.3 0-2.4 1-2.5 2.3v5h-1.6c-.1 0-.1-.1-.1-.1v-6.7c0-.6-.3-.6-.5-.7h-.3V12c0-.1.1-.1.1-.1.2-.2.5-.3.8-.2h.5c.6.2 1 .6 1.1 1.2v.2l.2-.2c.7-.9 1.7-1.4 2.8-1.4 1.2-.1 2.2.6 2.6 1.6l.1.2.1-.2c.7-1 1.8-1.6 3-1.7 2 0 2.9 1.2 2.9 3.7v3.7c0 .5.3.6.5.6h.3v.8c0 .1-.1.1-.1.1-.2.2-.3.2-.7.2-.1 0 0 0 0 0zm5.9 0c-2.3.1-4.3-1.7-4.4-4v-.3c-.3-2.4 1.5-4.4 3.8-4.7h.8c.9 0 1.8.3 2.6.7l.1.1.1 1.3c0 .1 0 .1-.1.1h-.1c-.7-.4-1.5-.7-2.3-.7h-.5c-1.7.2-2.9 1.7-2.7 3.3.2 1.5 1.4 2.6 2.8 2.7h.2c1 0 1.9-.4 2.7-1.1h.1c.1 0 .1 0 .1.1l.1 1.3v.1c-.8.7-1.9 1-2.9 1.1h-.4zm14.8-.2-.1-.1v-8.3c0-.1.1-.1.1-.1h1.3c.1 0 .1.1.1.1l.1 1.3.2-.2c.8-.8 1.9-1.3 3-1.2l.1.1v1.4h-.6c-1.3 0-2.4 1-2.5 2.3v4.7c0 .1-.1.1-.1.1h-1.6v-.1z",
    style: {
      fill: "#f0f8ff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandmarkFooterKnockout);
export default __webpack_public_path__ + "static/media/brandmark-footer-knockout.662a87bc54300ef148b25f3763a143c3.svg";
export { ForwardRef as ReactComponent };